import type { JSX } from 'react';
import { NumericFormat } from 'react-number-format';
import { DrawApi } from '@apply/api';
import { formatCurrencyConditional } from '../../totalItems/constants/constants';

interface IEquityRequirementProps {
    onEquityRequirementChange: (newValue: number) => void;
    drawBudget?: DrawApi.IDrawBudget;
    isAdmin: boolean;
    isReadOnly?: boolean;
}

export const EquityRequirement = ({
    drawBudget,
    isAdmin,
    onEquityRequirementChange,
    isReadOnly = false,
}: IEquityRequirementProps): JSX.Element => {
    return (
        <div>
            {isAdmin ? (
                <>
                    <div title={isReadOnly ? 'This Budget is read only.' : ''}>
                        <label htmlFor='equityRequirement'>Equity Requirement</label>
                        <NumericFormat
                            className='draw-header-input'
                            value={drawBudget?.equityRequirement}
                            placeholder={'$ 0'}
                            thousandSeparator={true}
                            prefix={'$ '}
                            onValueChange={(values) => onEquityRequirementChange(Number(values.value))}
                            disabled={isReadOnly}
                            decimalScale={2}
                            fixedDecimalScale={false}
                        />
                    </div>
                </>
            ) : (
                <>
                    <div style={{ fontSize: '11px', fontWeight: 'normal' }}>Equity Req:</div>
                    <div>{drawBudget?.equityRequirement ? formatCurrencyConditional(drawBudget?.equityRequirement) : '-'}</div>
                </>
            )}
        </div>
    );
};
